import React, { FunctionComponent, useMemo } from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import { useNavigate } from "react-router-dom";
import { useSelector } from 'react-redux';
import { Article, RootStore } from '../app/types';
import './ArticleThumb.css';
import Delayed from './Delayed';

interface ArticleProps {
    articleID: number
    pageNum: number
}

export const ArticleThumb: FunctionComponent<ArticleProps> = (props) => {
    const navigate = useNavigate();

    const articles = useSelector((state: RootStore) => state.articles);

    const article = useMemo(() =>
        articles.find((a: Article) => a.ID === props.articleID) ?? null,
        [articles, props.articleID]
    );

    const collectionArticles = useMemo(() => {
        if (!article) return [];
        return articles
            .filter((a: Article) => a.collectionID === article.collectionID)
            .sort((a: Article, b: Article) => a.orderIndex - b.orderIndex);
    }, [articles, article]);

    if (!article || collectionArticles.length === 0) {
        return <div />;
    }

    let articleClassName = "article-frame";
    if (props.articleID === collectionArticles[0].ID) {
        articleClassName += " left-article";
    }
    if (props.articleID === collectionArticles[collectionArticles.length-1].ID) {
        articleClassName += " right-article";
    }

    return <div onClick={() => navigate("/article/"+ props.articleID)}>
        <div className={articleClassName}>
            <div className="article-title">
                {article.name}
            </div>
            <div className="content-pane">
                <Delayed children={
                    <ReactMarkdown rehypePlugins={[rehypeRaw]}>
                        {article.content.replace('/image', '/thumb')}
                    </ReactMarkdown>
                } waitBeforeShow={props.pageNum * 100} />

            </div >
        </div>
    </div>;
}
